<template>
  <v-card>
    <v-card-text>
      <v-list dense>
        <upload-item
         v-for="a in uploads"
          :key="a.id"
          class="dense-list-item"
         :arquivo="a"></upload-item>
      </v-list>
      <v-list dense>
        <arquivo-item
         v-for="a in item.anexos"
          :key="a.id"
          class="dense-list-item"
         :arquivo="a" @remover="removerArquivo(a)"></arquivo-item>
      </v-list>
     </v-card-text>
  </v-card>
</template>
<style scoped>
.dense-list-item {
  padding: 0px;
  margin: 0px !important;
  min-height: 0px;
}
.inline-itens {
  flex-direction: row;
}
</style>
<script>
import Uppy from "@uppy/core";
import Tus from "@uppy/tus";
import "@uppy/core/dist/style.css";
import "@uppy/file-input/dist/style.css";
import * as ArquivoService from "@/services/arquivo.service";
import authHeader from "@/services/api/api.auth.header";
import Arquivo from "@/models/arquivo";
import ArquivoItem from './ArquivoItem.vue';
import UploadItem from './UploadItem.vue';

const ptBR = require("@uppy/locales/lib/pt_BR");

export default {
  props: {
    item: {
      type: Object,
     required: true,
    },
  },
  data() {
    return {
      cor_progresso: "primary",
      uploads: []
    };
  },
  components: {
    ArquivoItem,
    UploadItem
  },
  mounted() {
    this.instantiateUppy();
  },
  methods: {
    instantiateUppy() {
      this.uppy = Uppy({
        debug: false,
        autoProceed: true,
        restrictions: {
          minNumberOfFiles: 1,
          maxNumberOfFiles: 50,
          allowedFileTypes: ["*/*"],
        },
        locale: ptBR,
      })
        .use(Tus, {
          endpoint:
            process.env.VUE_APP_API_BASEURL +
            "prematricula/documentos/" +
            this.item.id +
            "/upload",
          headers: { Authorization: authHeader() },
          resume: true,
          autoRetry: true,
          limit: 10,
          removeFingerprintOnSuccess: true,
          retryDelays: [0, 1000, 3000, 5000],
        })
        // .on("progress", (p) => {
        //   this.progress = p;
        // })
        .on('upload-progress', (file, progress) => {
          this.onUploadProgress(file, progress)
        })
        .on("upload-success", (file, response) => {
          var id = this.uploadID(response.uploadURL);
          this.item.anexos.push(new Arquivo(id, file.name));
          this.uppy.removeFile(file.id);
          this.removeUpload(file);
        });
    },

    removeUpload(up){
      let idx = -1;
      for (let i = 0; i < this.uploads.length; i++) {
        const upload = this.uploads[i];
        if (upload.id == up.id) 
        idx = i;
      }
      if (idx > -1)
        this.uploads.splice(idx,1);
    },
    onUploadProgress(file, progress){
      this.uploads.map((u) => {if (u.id == file.id) u.progress = (progress.bytesUploaded / progress.bytesTotal) * 100 });
    },
    addFile(event) {
      let files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        let arquivo = files[i];
        let id = this.uppy.addFile({
          name: arquivo.name,
          type: arquivo.type,
          data: arquivo,
          source: "Local",
          isRemote: false,
        });
        this.uploads.push({id: id, nome: arquivo.name, progress: 0});
      }
    },
    removerArquivo(arquivo) {
      this.$nprogress.start();
      ArquivoService.rmvOne(arquivo.id)
        .then(() => {
          this.item.anexos.splice(
            this.item.anexos.indexOf(arquivo),
            1
          );
          this.$msg.warning("Arquivo removido!");
        })
        .finally(() => this.$nprogress.done());
    },
    uploadID(uploadURL) {
      return uploadURL.substring(uploadURL.length - 36);
    },
   },
   watch: { 
    item: function() {
      this.instantiateUppy()
    }
  }
};
</script>
